import httpRequest from "services/httpRequest";

const prefix = "/api/dashboard";

export const getDashboard = async () => {
  const result = await httpRequest({
    url: `${prefix}`,
    method: "GET",
  });
  return result;
};

export const getDashboardStatistic = async () => {
  const result = await httpRequest({
    url: `${prefix}/message-statistic`,
    method: "GET",
  });
  return result;
};
